export const changeKFXML = `
<?xml version="1.0" encoding="utf-8"?>
<msg brief="">
    <linear width="-1" cornerRadius="12" background="#FFFFFFFF" orientation="vertical">
		<linear width="-1" orientation="vertical" padding="32,24,32,24">
        	<text width="-1" height="-2" size="28" text="前面还有99个人排队，确定要切换吗？"/>
		</linear>
        <divider orientation="horizontal" width="-1" height="1" color="#FFEFEFF4"/>
        <linear width="-1" height="84" gravity="center">
            <text width="-1" weight="1" gravity="center" size="28" text="立即切换"  action="plugin" actionData="mqqwpa://im/qdmenu?version=1&amp;src_type=app&amp;isNeedReply=true&amp;isExt=false&amp;QidianPubID=0"  color="#FF0067ED"/>
        </linear>
    </linear>
</msg>
`;
